import styles from "../../styles/secret-settings.module.scss";
import { Title } from "../../shared/components/Title";
import { Icon } from "../../shared/components/core/Icon";
import { EnvironmentStorage } from "../../shared/tools/EnvironmentStorage";
import {
  SecretDrawerTypes,
  SecretSettingDrawer,
} from "../../shared/containers/Settings/SecretSettingDrawer";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ForEach } from "../../shared/components/control-statements/ForEach";

const SettingItem = ({ setting, onClick }) => {
  return (
    <Link to={setting.visible !== false && setting.path}>
      <div
        className={styles.setting}
        style={{ opacity: setting.show !== false ? 1 : 0.3 }}
        onClick={() => setting.show && setting.alias && onClick(setting.alias)}
      >
        <div className={styles.icon}>{setting.icon}</div>
        <p>{setting.name}</p>
      </div>
    </Link>
  );
};

const SettingGroup = ({ group, onClickButton }) => {
  return (
    <div>
      <div className={styles.header}>
        <p>
          {group.name} ({group.items.length})
        </p>
      </div>
      <div className={styles.settings}>
        <ForEach
          items={group.items}
          render={(setting) => {
            return <SettingItem setting={setting} onClick={onClickButton} />;
          }}
        />
      </div>
    </div>
  );
};

export default function SecretSettings() {
  const environment = EnvironmentStorage.getEnvironment();
  const [showDrawer, setShowDrawer] = useState(false);

  const settingGroups = [
    {
      name: "Geral",
      items: [
        {
          name: "Tema do Gestor",
          show: true,
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.GESTOR_THEME,
        },
        {
          name: "Configurações SEO",
          show: true,
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.GESTOR_SEO,
        },
      ],
    },
    {
      name: "Unidades",
      items: [
        {
          name: `Credenciais Open Delivery`,
          show: environment.type != "BRAND",
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.OPEN_DELIVERY,
        }, 
        {
          name: `Sincronizar cardápio Open Delivery`,
          show: environment.type != "BRAND",
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.REFRESH_OPEN_DELIVERY,
        },
        {
          name: `Região de entrega (KML)`,
          show: environment.type != "BRAND",
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.KML_DELIVERY,
        },
      ],
    },
    {
      name: "Marcas",
      items: [
        {
          name: "Domínio",
          show: false,
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.GESTOR_THEME,
        },
        {
          name: `Fidelidade`,
          show: environment.type == "BRAND",
          icon: <Icon name="money-bill-transfer" size="lg" />,
          alias: SecretDrawerTypes.CASHBACK_CONFIGURATION,
        },
        {
          name: `Menus benefícios e avaliação`,
          show: environment.type == "BRAND",
          icon: <Icon name="gift" size="lg" />,
          alias: SecretDrawerTypes.EXTRA_MENUS,
        },
        {
          name: "Links de aplicativo",
          show: environment.type == "BRAND",
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.APP_LINKS_BRAND,
        },
        {
          name: "Registro de endereços",
          show: environment.type == "BRAND",
          icon: <Icon name="map-marker-alt"/>,
          alias: SecretDrawerTypes.ADDRESS_PREFERENCES,
        },
        {
          name: "Campos personalizados",
          show: environment.type == "BRAND",
          icon: <Icon name="list" size="lg" />,
          alias: SecretDrawerTypes.CUSTOMER_ATTRIBUTES,
        },
      ],
    },
    {
      name: "Holding",
      items: [
        {
          name: `Logo`,
          show: true,
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.BRAND_LOGO,
        },
        {
          name: `Banners`,
          show: true,
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.HOLDING_BANNER,
        },
        {
          name: "Domínio",
          show: false,
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.GESTOR_THEME,
        },
        {
          name: "Credenciais Olga",
          show: true,
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.HOLDING_OLGA,
        },
        {
          name: "Links de aplicativo",
          show: true,
          icon: <Icon name="image-polaroid" light />,
          alias: SecretDrawerTypes.APP_LINKS_HOLDING,
        },
      ],
    },
    {
      name: "Automações",
      items: [
        {
          name: "Cancelar pedidos em aberto",
          show: true,
          icon: <Icon name="times" size="lg" />,
          alias: SecretDrawerTypes.AUTO_CANCEL_OPENED,
        },
      ],
    },
  ];

  const getSubtitle = () => {
    if (environment?.brand)
      return (
        `${environment.brand.name} - ${environment.name}` +
        (environment.active === false ? " (Inativa)" : "")
      );
    return environment?.name;
  };

  return (
    <div className={styles.secretContainer}>
      <Title title="Configurações ocultas" subtitle={getSubtitle()} />
      <ForEach
        items={settingGroups}
        render={(group, index) => {
          return (
            <SettingGroup
              group={group}
              onClickButton={(drawer) => setShowDrawer(drawer)}
            />
          );
        }}
      />
      {showDrawer && (
        <SecretSettingDrawer
          visible={showDrawer}
          setting={showDrawer}
          onClose={() => setShowDrawer(false)}
          onSave={() => setShowDrawer(false)}
        />
      )}
    </div>
  );
}
